var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercardLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0a1329",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff5f00",
  d: "M19.06 6.5h-6.12v11h6.12z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eb001b",
  d: "M13.33 12A6.99 6.99 0 0 1 16 6.5a7 7 0 1 0 0 11 6.99 6.99 0 0 1-2.67-5.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f79e1b",
  d: "M27.33 12A7 7 0 0 1 16 17.5a7 7 0 0 0 0-11A7 7 0 0 1 27.33 12"
})));
export default SvgMastercardLight;